module.exports = __webpack_public_path__ + "static/media/mashya_thumb_even.a5453bb0.jpg";